import React, { useState } from "react";
import { login, saveSession } from "./auth";

const PRIMARY = "#000000";

export default function LoginPage({ onLoggedIn }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showPass, setShowPass] = useState(false);

  const [isLoading, setIsLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  const canSubmit = username.trim().length > 0 && password.length > 0 && !isLoading;

  async function handleSubmit(e) {
    e.preventDefault();
    setErrorMsg("");

    if (!username.trim()) return setErrorMsg("Enter your username.");
    if (!password) return setErrorMsg("Enter your password.");

    setIsLoading(true);
    try {
      const session = await login(username, password);
      if (!session) {
        setErrorMsg("Wrong username or password.");
        return;
      }
      saveSession(session);
      onLoggedIn?.(session);
    } catch (err) {
      setErrorMsg("Something went wrong. Please try again.");
    } finally {
      setIsLoading(false);
    }
  }

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <div style={styles.brand}>mock-app</div>

        <h1 style={styles.title}>Login</h1>

        <form onSubmit={handleSubmit} style={styles.form} noValidate>
          <label style={styles.label}>
            Username
            <input
              style={styles.input}
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="username"
              autoComplete="username"
              dir="ltr"
            />
          </label>

          <label style={styles.label}>
            Password
            <div style={styles.passRow}>
              <input
                style={{ ...styles.input, marginBottom: 0 }}
                type={showPass ? "text" : "password"}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••"
                autoComplete="current-password"
                dir="ltr"
              />
              <button
                type="button"
                onClick={() => setShowPass((s) => !s)}
                style={styles.showBtn}
                disabled={isLoading}
              >
                {showPass ? "Hide" : "Show"}
              </button>
            </div>
          </label>

          {errorMsg ? <div style={styles.error}>{errorMsg}</div> : null}

          <button type="submit" disabled={!canSubmit} style={styles.submit}>
            {isLoading ? "Signing in..." : "Sign in"}
          </button>
        </form>

        <p style={styles.notice}>
          This website is experimental, non-profit and for internal use only.
        </p>
      </div>
    </div>
  );
}

const styles = {
  page: {
    minHeight: "100vh",
    display: "grid",
    placeItems: "center",
    padding: 18,
    background: "#f3f5f9",
  },
  card: {
    width: "100%",
    maxWidth: 440,
    background: "#fff",
    border: "1px solid #eee",
    borderRadius: 18,
    padding: 26,
    boxShadow: "0 12px 30px rgba(0,0,0,0.10)",
  },
  brand: {
    textAlign: "center",
    fontWeight: 800,
    fontSize: 24,
    marginBottom: 12,
    color: "#111827",
  },
  title: { margin: 0, fontSize: 28, fontWeight: 800, marginBottom: "1rem" },
  form: { display: "grid", gap: 14 },
  label: { display: "grid", gap: 8, fontSize: 13, color: "#111827" },
  input: {
    width: "100%",
    padding: "12px 14px",
    borderRadius: 14,
    border: "1px solid #d7dbe3",
    outline: "none",
    fontSize: 14,
    background: "#fff",
  },
  passRow: {
    display: "grid",
    gridTemplateColumns: "1fr auto",
    gap: 10,
    alignItems: "center",
  },
  showBtn: {
    padding: "10px 14px",
    borderRadius: 14,
    border: "1px solid #d7dbe3",
    background: "#f7f8fb",
    cursor: "pointer",
    fontSize: 13,
    whiteSpace: "nowrap",
  },
  submit: {
    padding: "12px 14px",
    borderRadius: 14,
    border: "none",
    background: PRIMARY,
    color: "#fff",
    cursor: "pointer",
    fontSize: 15,
    fontWeight: 700,
    marginTop: 4,
    opacity: 1,
  },
  error: {
    background: "#fff2f2",
    color: "#b42318",
    border: "1px solid #fecaca",
    padding: 10,
    borderRadius: 14,
    fontSize: 13,
  },
  notice: {
    marginTop: 18,
    marginBottom: 0,
    textAlign: "center",
    color: "#92400e",
    background: "#fde68a",
    border: "1px solid #f59e0b",
    borderRadius: 12,
    padding: "10px 12px",
    fontSize: 12,
    fontWeight: 600,
    lineHeight: 1.5,
  },
};
